module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAAt0lEQVQ4je3TMUpDQRCH8d+TdBY5g+QOokjukTp4qHQBT2BhF7ASBEmTAySmtLG0C/xT5EHWF3yEF4sIfjCwCzMfw85slWSAOzxgikt84QMLzPCpjewpzyWbJE9JhnXOQRwjKZkluWlKqiSpm6qQtq4L5njECrddJd+46FL0L/lLkl7j/opnvOHd7g9d4R6jHy2NtW+LcZJ1kb9MMkly3dzYY+hjU3e5K+wgOeB8pvNrI35xwnvAFk0N2IjR5H3CAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master/ico2.png
// module id = vjUN
// module chunks = 11